// eslint-disable-next-line import/prefer-default-export
export const SessionStorageKeys = {
  onboardingCompleteStepsFormatForceFlag: 'force_variant_30829',
  onboardingCompleteDownloadOrderForceFlag: 'force_variant_42106',
  locale: 'locale'
}
